/**
 * UserRoles actions script file
 *
 * @package    Actions
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights
 *     reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import UserRolesApi from 'Api/userRoles';
import { clearAutocomplete as clearJournalAutocomplete } from './journal';

export const USER_ROLES_LIST_REQUEST = 'USER_ROLES_LIST_REQUEST';
export const USER_ROLES_LIST_SUCCESS = 'USER_ROLES_LIST_SUCCESS';
export const USER_ROLES_LIST_ERROR = 'USER_ROLES_LIST_ERROR';
export const USER_ROLES_LIST_UPDATE_FILTER = 'USER_ROLES_LIST_UPDATE_FILTER';

export const USER_ROLES_HISTORY_LIST_REQUEST = 'USER_ROLES_HISTORY_LIST_REQUEST';
export const USER_ROLES_HISTORY_LIST_SUCCESS = 'USER_ROLES_HISTORY_LIST_SUCCESS';
export const USER_ROLES_HISTORY_LIST_ERROR = 'USER_ROLES_HISTORY_LIST_ERROR';
export const USER_ROLES_HISTORY_LIST_UPDATE_FILTER = 'USER_ROLES_HISTORY_LIST_UPDATE_FILTER';

export const USER_ROLE_STORE_REQUEST = 'USER_ROLE_DELETE_REQUEST';
export const USER_ROLE_STORE_SUCCESS = 'USER_ROLE_STORE_SUCCESS';
export const USER_ROLE_STORE_ERROR = 'USER_ROLE_STORE_ERROR';

export const USER_ROLE_DELETE_REQUEST = 'USER_ROLE_DELETE_REQUEST';
export const USER_ROLE_DELETE_SUCCESS = 'USER_ROLE_DELETE_SUCCESS';
export const USER_ROLE_DELETE_ERROR = 'USER_ROLE_DELETE_ERROR';

/**
 * Load roles list
 *
 * @param {number} filter
 * @returns {*}
 */
export function loadUserRoles(filter = {}) {
    return {
        requestType: 'USER_ROLES_LIST',
        request: UserRolesApi.findUserRoles(filter),
    };
}

/**
 * Update filter
 *
 * @param {Object} filter
 *
 * @return {Object}
 */
export function updateRolesFilter(filter = {}) {
    return {
        type: USER_ROLES_LIST_UPDATE_FILTER,
        payload: filter,
    };
}

/**
 * Load roles history list
 *
 * @param {number} filter
 * @returns {*}
 */
export function loadUserRolesHistory(filter = {}) {
    return {
        requestType: 'USER_ROLES_HISTORY_LIST',
        request: UserRolesApi.findUserRolesHistory(filter),
    };
}

/**
 * Update history filter
 *
 * @param {Object} filter
 *
 * @return {Object}
 */
export function updateRolesHistoryFilter(filter = {}) {
    return {
        type: USER_ROLES_HISTORY_LIST_UPDATE_FILTER,
        payload: filter,
    };
}

/**
 * Store user role
 *
 * @param id
 * @returns {{requestType: string, request: function(*)}}
 */
export function storeUserRole(id) {
    return {
        requestType: 'USER_ROLE_STORE',
        request: UserRolesApi.storeUserRole(id),
        success: (response, dispatch) => {
            dispatch(clearJournalAutocomplete());

            return {
                payload: response,
            };
        },
    };
}

/**
 * Delete user role
 *
 * @param id
 * @returns {{requestType: string, request: function(*)}}
 */
export function deleteUserRole(id) {
    return {
        requestType: 'USER_ROLE_DELETE',
        request: UserRolesApi.deleteUserRole(id),
    };
}



// WEBPACK FOOTER //
// ./src/actions/userRoles.js